import { render } from "./RoomManagementIndex.vue?vue&type=template&id=39f012e1"
import script from "./RoomManagementIndex.vue?vue&type=script&lang=js"
export * from "./RoomManagementIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__